// QuoteWindow — a quote opens in the movable window (ui/Modal variant="window"),
// the same frame as the customer window, not a page: the list stays where it was.
// The body is the real quote screen (QuoteDetail), so every action it has works
// here exactly as on /quotes/:id. Delete (the old row menu's) lives in the
// window's header and asks twice in place — no browser dialog.
import React, { useState } from "react";
import Modal from "../ui/Modal";
import Button from "../ui/button";
import revivalApi from "../../api/revivalApi";
import QuoteDetail from "../../pages/Quotes/QuoteDetail";
import { money, quoteTotal, statusLabel } from "./revivalData";

export default function QuoteWindow({ quote, onClose, onDeleted }) {
  const [confirming, setConfirming] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState("");
  if (!quote?.id) return null;
  const title = [quote.quote_number, quote.customer_name].map((s) => String(s || "").trim()).filter(Boolean).join(" · ") || "Quote";

  const remove = async () => {
    setDeleting(true);
    setError("");
    try {
      await revivalApi.deleteQuote(quote.id);
      onDeleted?.(quote.id);
      onClose?.();
    } catch (err) {
      setError(`Delete failed: ${err?.message || "unknown error"}`);
      setDeleting(false);
      setConfirming(false);
    }
  };

  const actions = onDeleted ? (
    confirming ? (
      <>
        <Button size="sm" variant="ghost" onClick={() => setConfirming(false)} disabled={deleting}>Keep</Button>
        <Button size="sm" variant="danger" onClick={remove} loading={deleting}>Delete this quote</Button>
      </>
    ) : (
      <Button size="sm" variant="ghost" onClick={() => setConfirming(true)}>Delete</Button>
    )
  ) : null;

  return (
    <Modal
      open
      onClose={onClose}
      variant="window"
      windowKey="quote"
      className="rv-quote-window"
      title={title}
      status={statusLabel(quote.status)}
      meta={<span className="rv-window-meta">{money(quoteTotal(quote))}</span>}
      actions={actions}
      banner={error ? <span role="alert">{error}</span> : null}
    >
      <QuoteDetail quoteId={String(quote.id)} onClose={onClose} inWindow />
    </Modal>
  );
}
